export enum SWMessageType {
  UPLOAD_DATA = 'UPLOAD_DATA',
  UPLOAD_STATUS = 'UPLOAD_STATUS',
  AUTH_ERROR = 'AUTH_ERROR',
  USER_IDENTITY = 'USER_IDENTITY',
  CONFIG = 'SENTRY_CONFIG',
  UPLOAD_LOCATION_EVIDENCE = 'UPLOAD_LOCATION_EVIDENCE',
}
